export default "__VITE_ASSET__D6efQY7m__"